import * as ActionTypes from '../../actions/ActionTypes';
import Article from '../../records/ArticleRecord';
import ArticleDetailsRecord from '../../records/insights/ArticleDetailsRecord';
const INITIAL_STATE = new ArticleDetailsRecord();
export default function articleDetailsInfo(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.FETCH_ARTICLE_DETAILS_PENDING:
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined
      });
    case ActionTypes.FETCH_ARTICLE_DETAILS_SUCCESS:
      return state.merge({
        article: new Article(action.payload),
        error: undefined,
        isRequesting: false,
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_SUCCESS:
      return state.update('article', article => article.updateVisibility(action.payload.data)).merge({
        error: undefined,
        isRequesting: false,
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.FETCH_ARTICLE_DETAILS_ERROR:
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    case ActionTypes.RESET_ARTICLE_DETAILS:
      return INITIAL_STATE;
    default:
      return state;
  }
}